var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlexi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_25013)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M52.708 42.9818C52.708 44.8724 52.1924 46.6771 51.2471 48.224C50.9033 48.7396 50.5596 49.2552 50.2158 49.6849C49.3564 50.7162 48.3252 51.4896 47.1221 52.0912C46.6064 52.349 46.0908 52.6068 45.4893 52.7787C44.5439 53.1224 43.5127 53.2943 42.3955 53.2943C36.7236 53.2943 32.083 48.6537 32.083 42.9818C32.083 41.8646 32.2549 40.8334 32.5986 39.8021C32.7705 39.2006 33.0283 38.6849 33.2861 38.1693C35.0049 34.9037 38.4424 32.5834 42.4814 32.5834C48.0674 32.6693 52.708 37.3099 52.708 42.9818Z",
    fill: "#8CC63E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.501 0.5L4.07617 15.0681V40.8481L27.501 55.5L50.9259 40.8481V15.0681L27.501 0.5ZM27.501 2.74641L47.1777 15.0686L27.501 27.3903L7.82434 15.0681L27.501 2.74641ZM6.0016 16.2682L26.5385 29.0398V52.625L6.0016 39.7829V16.2682ZM49.0004 39.7829L28.4635 52.625V29.0398L49.0004 16.2687V39.7829Z",
    fill: "#303940"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_25013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexi);
export default __webpack_public_path__ + "static/media/Flexi.f8aa9b90a1f02bbb7dc13388fe8c353f.svg";
export { ForwardRef as ReactComponent };